var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-5"},[(_vm.editor)?_c('div',[_c('rich-text-editor-menu-bar',{staticClass:"editor__header",attrs:{"editor":_vm.editor}})],1):_vm._e(),[_c('editor-content',{attrs:{"editor":_vm.editor}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }